import React, {useEffect, useMemo, useState} from 'react'
// import axios from "axios";
// import SidebarItem from "../../Sidebar/SidebarItem";
// import PageHandler from "../../CommonComponents/PageHandler";
// import MapAnalysis from "../../CommonComponents/MapAnalysis";
// import Input from '../../CommonComponents/Input';
// import Tesla from "../../CommonComponents/Tesla";
import MUIBtn from "../../CommonComponents/MUIBtn";
import PaperJS from "../../CommonComponents/Paper";
import Image from "../../CommonComponents/Image";
import ApexPieChartJS from "../../CommonComponents/ApexPieChartJS";
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import { blue } from '@mui/material/colors';
import TeslaPng from '../../../assets/Tesla.png';
import TextFieldJS from "../../CommonComponents/TextFieldJS";
import {IconButton, InputAdornment} from "@mui/material";
import {Link} from 'react-router-dom';
const Home = () => {
    const [activatedButtons, setActivatedButtons] = useState([])
    const [label, setLabel] = useState('Earnings Calls')
    const handleButton = (btnName, label) =>{
        setLabel(label);
        let filteredButtons = activatedButtons.includes(btnName) ? activatedButtons.filter((btn)=>btn!==btnName): [...activatedButtons, btnName];
        setActivatedButtons(filteredButtons);
    };
    return (
        <div className={'flex flex-col sm:flex-row'}>
            {/*<div className={'w-35 bg-grey rounded-md p-2'}>*/}
            {/*    */}
            {/*</div>*/}
            <div className={'m-2 w-100 sm:w-60 l:50 sm:mr-2 mr-2'}>
            <div className={'bg-grey block sm:flex md:flex justify-evenly rounded-md p-2 mb-2'}>
              {/*  <TextField*/}
              {/*  id="outlined-basic"*/}
              {/*  // label="Search your item..."*/}
              {/*  variant="outlined"*/}
              {/*  style={{ backgroundColor: 'white', height: '10px' }}*/}
              {/*  placeholder="Search your item..."*/}
              {/*/>*/}
                <div className={'w-100 sm-55 sm:mb-0 mb-2 mr-2'}>
                <TextFieldJS placeholder={'Search your items...'} className={'w-100 sm-55 sm:mr-2 mr-2'} inputProps={<InputAdornment position="end">
                          <IconButton style={{ backgroundColor: blue[500] }}>
                            <SearchIcon style={{ color: 'white', borderRadius: '8px' }} />
                          </IconButton>
                        </InputAdornment>
                    } style={{backgroundColor: 'white', borderRadius: '8px'}}/>
                    </div>
                <div className={'flex items-center justify-between sm:justify-center bg-white rounded-lg w-100 sm:w-90'}>
                    <Image src={TeslaPng} height={'30px'} width={"30px"}/>
                    <span className={'text-l'}>Tesla&nbsp;<span className={'text-red-500'}>241(-2.00%)</span></span>
                </div>
            </div>
                <div className={'bg-grey rounded-md p-2'}>
                <MUIBtn name={'Earnings'} onClick={handleButton} activatedButtons={activatedButtons}/>
                <MUIBtn name={'10Q/K'}  onClick={handleButton} activatedButtons={activatedButtons}/>
                <MUIBtn name={'8K'} onClick={handleButton} activatedButtons={activatedButtons}/>
                <MUIBtn name={'Clinical Research'} onClick={handleButton} activatedButtons={activatedButtons}/>
                <MUIBtn name={'Company Doc'} onClick={handleButton} activatedButtons={activatedButtons}/>
                <MUIBtn name={'Miscellaneous'} onClick={handleButton} activatedButtons={activatedButtons}/>
                <hr className="mt-2 border-t-2 border-grey" />
                <div className="flex justify-evenly" >
                    <div className={'w-40 mt-2'}>
                        <PaperJS />
                    </div>
                    <div style={{backgroundColor: 'gray'}} className=" bg-gray-700 rounded-lg w-05 ">
                </div><div className={' mt-2 w-55'}>
                        <PaperJS type='QuarterAnalysis' label={label}/>
                    </div></div>
            </div>
                </div>
            <div id={'right-portion'} className={'bg-grey w-100 sm:w-100 rounded-md p-2 m-2'}>
                <div className={'flex justify-evenly items-center h-20vh m-2'}>
                    <div className={'w-50'}>
                        {/*<ApexPieChartJS/>*/}
                        {/*<ApexPieChartJS/>*/}
                    </div>
                    <div className={'w-50 flex justify-center h-15 items-center'}>
                        <div>
                            <Link className={'block text-blue-600'}>Menu 1</Link>
                            <Link className={'block text-blue-600'}>Menu 2</Link>
                            <Link className={'block text-blue-600'}>Menu 3</Link>
                            <Link className={'block text-blue-600'}>Menu 4</Link>
                            <Link className={'block text-blue-600'}>Menu 5</Link>
                        </div>
                    </div>

                </div>
                <div className={'m-2'}>
                <TextFieldJS placeholder={'keyword search...'} inputPropStyle={{color: 'white'}} inputProps={<InputAdornment position="end">
                          <IconButton style={{ backgroundColor: blue[500]}}>
                            <SearchIcon style={{ color: 'white' }} />
                          </IconButton>
                        </InputAdornment>
                    } style={{backgroundColor: '#494040', borderRadius: '8px', width: '55%'}}/>
                </div>
                <div style={{color: 'white'}} className={'bg-gray-1 rounded-md m-2'}>
                    <h1 className={'text-xl p-4'}>Q1 2023 Earning Calls</h1>
                    <p className={'p-4 pt-0 mb-0 max-h-50vh overflow-auto'}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Exce labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, state velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </div>
                <div className={'m-2'}>

                <TextFieldJS placeholder={'Ask a question'}  inputPropStyle={{color: 'white'}} inputProps={<InputAdornment position="end">
                          <IconButton>
                            <SendIcon style={{ color: 'white', borderRadius: '8px'  }} />
                          </IconButton>
                        </InputAdornment>
                    } style={{backgroundColor: 'gray', borderRadius: '8px', width: '100%', marginTop: '10px'}}/>
                </div>
            </div>
        </div>
    )
}
export default Home;